import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { AlertTriangle } from "lucide-react";
import { Req } from "@/components/newTicket/parts";

export default function TicketTypeSection({ ticketTypes, value, onChange, typeMeta, switchWarn }) {
  return (
    <section data-testid="section-ticket-type">
      <div className={`flex flex-col sm:flex-row sm:items-end gap-4 rounded-lg p-4 border ${typeMeta ? typeMeta.softBg + " " + typeMeta.softBorder : "bg-indigo-50/40 border-indigo-100"}`}>
        <div className="flex-1">
          <Label className="text-xs font-semibold text-slate-700">
            Ticket Type<Req />
          </Label>
          <Select value={value} onValueChange={onChange}>
            <SelectTrigger className="mt-1.5 h-10 bg-white" data-testid="ticket-type-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {ticketTypes.map((t) => (
                <SelectItem key={t.id} value={t.name}>{t.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          {switchWarn && (
            <div className="mt-2 inline-flex items-center gap-1.5 text-[11px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1"
                 data-testid="type-switch-warning">
              <AlertTriangle className="w-3 h-3" />
              You switched type after filling several fields — review before submitting.
            </div>
          )}
        </div>
        <p className="text-xs text-slate-500 sm:max-w-sm">
          <span className="font-medium text-slate-700">Inbound</span>: calls/chats/social/email coming in from customers.{" "}
          <span className="font-medium text-slate-700">Service Call</span>: offline leads, walk-ins, internal referrals.
        </p>
      </div>
    </section>
  );
}
